<template>
  <div>

  </div>
</template>

<script>
  export default {
    name: 'main'
  }
</script>

<style lang="scss" scoped>

</style>